//--- ARQUIVO NOVO: DasGuideModal.js (Copie e cole tudo) ---
import React from 'react';

export const DasGuideModal = ({ onConfirm, onCancel }) => {
    const currentYear = new Date().getFullYear();

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-lg">
                <div className="p-6">
                    <h3 className="text-xl font-bold dark:text-gray-200 mb-4">Gerando sua Guia do DAS</h3>
                    <p className="text-green-600 dark:text-green-400 font-semibold mb-4">
                        Seu CNPJ já foi copiado para a área de transferência! ✅
                    </p>
                    <p className="dark:text-gray-300 mb-4">
                        A página da Receita Federal foi aberta em uma nova aba. Siga estes passos lá:
                    </p>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700 dark:text-gray-300">
                        <li><strong>Cole (Ctrl+V)</strong> o seu CNPJ no campo solicitado e clique em "Continuar".</li>
                        <li>Clique no menu "Emitir Guia de Pagamento (DAS)".</li>
                        <li>Selecione o ano (<strong>{currentYear}</strong>) e clique em "Apurar/Gerar DAS".</li>
                        <li>Marque o mês que deseja pagar e clique em "Gerar DAS".</li>
                    </ol>
                    <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">
                        Depois de pagar o boleto, não se esqueça de voltar aqui e marcar o mês como 'Pago'!
                    </p>
                </div>
                <div className="bg-gray-50 dark:bg-gray-700/50 px-6 py-4 flex justify-end rounded-b-lg">
                    <button onClick={onConfirm} className="px-4 py-2 bg-blue-600 text-white rounded-md">Ok, entendi!</button>
                </div>
            </div>
        </div>
    );
};